import script from "./SectionTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&setup=true&lang=ts"

import "./SectionTitle.vue?vue&type=style&index=0&id=576bf1fa&lang=scss"

const __exports__ = script;

export default __exports__